import { Spinner } from '@space-core/components/spinner'

const CustomSpinner = () => (
  <div
    className='_d-flex _align-items-center _justify-content-center _px-6 _flex-nowrap _ml-auto _text-nowrap'
    data-test='custom-spinner'>
    <Spinner color='var(--gray-600)' size='2rem' borderSize='0.25rem' />
  </div>
)

export default CustomSpinner
